import ADDRESS from '../../../api/address';
import addressModel from '../../models/persons/address-model.js';

const state = {
  address: addressModel(),
  addresses: [],
  popupActive: false,
};

const getters = {};

const actions = {
  addressesBy({ commit }, person = undefined) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ADDRESS.addressesBy(person).then(response => {
        commit('setAddresses', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  storeAddress({ commit, dispatch, state }, person) {
    commit('LOADER/setLoading', true, { root: true });

    return new Promise((resolve, reject) => {
      commit('setAddressPersonOwner', person);
      ADDRESS.store(state.address).then(response => {
        dispatch('addressesBy', person);
        commit('clearAddress');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  async store({ commit, dispatch, state }, { person = undefined } = {}) {
    commit('setAddressPersonOwner', person);
    const address = await ADDRESS.store(state.address);
    await dispatch('addressesBy', person);

    return address;
  },
  updateAddress({ commit, dispatch, state }, person) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ADDRESS.update(state.address).then(response => {
        dispatch('addressesBy', person);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showAddress({ commit, dispatch }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ADDRESS.show(id).then(response => {
        commit('setAddress', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  destroyAddress({ commit, dispatch }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ADDRESS.destroy(payload.id).then(response => {
        dispatch('addressesBy', payload.person);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  clearAddress({ commit }) {
    commit('clearAddress');
  },
  searchByPostalCode({ commit }, postalCode) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      ADDRESS.searchByPostalCode(postalCode).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
};

const mutations = {
  //addresses
  setStreet(state, street) {
    state.address.street = street;
  },
  setHouseNumber(state, house_number) {
    state.address.house_number = house_number;
  },
  setFlatNumber(state, flat_number) {
    state.address.flat_number = flat_number;
  },
  setPostalCode(state, postal_code) {
    state.address.postal_code = postal_code;
  },
  setCity(state, city) {
    state.address.city = city;
  },
  setPostOffice(state, post_office) {
    state.address.post_office = post_office;
  },
  setBorough(state, borough) {
    state.address.borough = borough;
  },
  setCounty(state, county) {
    state.address.county = county;
  },
  setVoivodeship(state, voivodeship) {
    state.address.voivodeship = voivodeship;
  },
  setCountry(state, country) {
    state.address.country = country;
  },
  storeAddress(state, address) {
    state.addresses.push(address);
  },
  clearAddress(state) {
    state.address = addressModel();
  },
  setAddress(state, address) {
    state.address = address;
  },
  setAddresses(state, addresses) {
    state.addresses = addresses;
  },
  setAddressPersonOwner(state, person) {
    state.address.person = person;
    state.address.owner = JSON.parse(localStorage.getItem('person')).id;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
